import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  faArrowUpBigSmall,
  faArrowDownSmallBig,
} from '@fortawesome/pro-light-svg-icons';
import { isNull } from 'lodash';
import { Button } from '../Button';
import { Text } from '../Text';

interface IRevealingBox {
  className?: string;
  children: any;
  height: number;
  value?: boolean | null;
}

type StyledRevealingBoxProps = {
  height: number;
};

export const StyledRevealingBox = styled.div<StyledRevealingBoxProps>`
  max-height: ${({ height }) => rem(`${height}px`)};
  position: relative;
  overflow: hidden;
  margin-bottom: ${rem(`24px`)};
  .readmore-link {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    display: block;
    width: 100%;
    height: ${rem(`80px`)};
    text-align: center;
    padding-top: ${rem(`48px`)};
    background-image: linear-gradient(
      to bottom,
      transparent,
      ${({ theme }) => theme.colors.blue_1_90}
    );
    cursor: pointer;
  }
  &.expanded {
    max-height: ${rem(`5000px`)} !important;
    transition: max-height 0.35s ease-in-out;
    .readmore-link {
      position: relative;
      background-image: none;
      padding-top: ${rem(`16px`)};
      height: ${rem(`48px`)};
    }
  }
`;

export const RevealingBox = ({
  className,
  children,
  height,
  value = false,
}: IRevealingBox) => {
  const [isExpanded, setExpanded] = useState(value);
  const itemRef = useRef(null);

  useEffect(() => {
    if (isNull(value) || value === isExpanded) {
      return;
    }
    setExpanded(value);
  }, [value]);

  return (
    <div ref={itemRef}>
      {itemRef.current?.clientHeight < height ? (
        children
      ) : (
        <StyledRevealingBox
          height={height}
          className={`${className} ${isExpanded && `expanded`}`}
        >
          {children}
          <div className="readmore-link">
            <Button
              onClick={() => setExpanded(!isExpanded)}
              size="small"
              iconRight={isExpanded ? faArrowUpBigSmall : faArrowDownSmallBig}
            >
              <Text type="body3" tag="span" color="white_1_45">
                {isExpanded ? `Shrink` : `Expand`}
              </Text>
            </Button>
          </div>
        </StyledRevealingBox>
      )}
    </div>
  );
};
